import React, { useState } from 'react';
import { IDevice } from '../../interfaces';
import { MapWrapper } from './MapView';

export const ConflictsScreenView = (props: { devices: IDevice[]; close: () => void }) => {
    const [state, setState] = useState({
        closing: false
    });

    return (
        <div
            className={`modal-background${state.closing ? ' closing' : ''}`}
            onClick={(e) => {
                if (e.target === e.currentTarget) {
                    setState({
                        ...state,
                        closing: true
                    });

                    setTimeout(props.close, 200);
                }
            }}
        >
            <div className="modal">
                <div className="flex-conflicts">
                    <h6>Ecrans</h6>
                    <div className="flex-conflicts-col">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Magasin</th>
                                    <th>Enseigne</th>
                                    <th>Ville</th>
                                    <th>Zip</th>
                                </tr>
                            </thead>
                            <tbody>
                                {props.devices.map((d) => (
                                    <tr key={d.id}>
                                        <td>{d.id}</td>
                                        <td>{d.Shop.name}</td>
                                        <td>{d.Shop.Sign.name}</td>
                                        <td>{d.Shop.city}</td>
                                        <td>{d.Shop.zip}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <div className="map-conflicts">
                            <MapWrapper devices={props.devices} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
